import { useEffect } from 'react';

const BlogSchema = () => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Blog i saveti | PHYSIOWRLD",
      "description": "Stručni članci o fizikalnoj terapiji, rehabilitaciji, laser terapiji i oporavku pacijenata. Saveti fizioterapeuta PHYSIOWRLD centra iz Novog Beograda.",
      "url": "https://physiowrld.rs/blog",
      "publisher": {
        "@type": "Organization",
        "name": "PHYSIOWRLD",
        "logo": {
          "@type": "ImageObject",
          "url": "https://physiowrld.rs/images/physiowrld-logo.webp"
        }
      },
      "blogPost": [
        {
          "@type": "BlogPosting",
          "headline": "Fizikalna terapija za bol u leđima – vodič kroz oporavak",
          "alternativeHeadline": "Kako fizikalna terapija pomaže kod bola u leđima i kičmi",
          "description": "Saznajte koje vežbe i tretmani pomažu kod bola u leđima i kako PHYSIOWRLD pristup donosi brži i trajniji oporavak.",
          "image": "https://physiowrld.rs/images/blog/fizikalna-terapija-bol-u-ledjima.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/fizikalna-terapija-bol-u-ledjima",
          "datePublished": "2025-10-25",
          "dateModified": "2025-10-25"
        },
        {
          "@type": "BlogPosting",
          "headline": "Rehabilitacija posle operacije kolena – faze oporavka",
          "alternativeHeadline": "Vodič kroz faze rehabilitacije posle operacije kolena",
          "description": "Kako izgleda rehabilitacija posle operacije kolena – faze, vežbe i saveti fizioterapeuta iz PHYSIOWRLD centra.",
          "image": "https://physiowrld.rs/images/blog/rehabilitacija-posle-operacije-kolena.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/rehabilitacija-posle-operacije-kolena",
          "datePublished": "2025-10-20",
          "dateModified": "2025-10-20"
        },
        {
          "@type": "BlogPosting",
          "headline": "Laserska terapija u fizikalnoj medicini – sve što treba da znate",
          "alternativeHeadline": "Prednosti i primena laserske terapije u fizikalnoj medicini",
          "description": "Laserska terapija ubrzava regeneraciju tkiva i ublažava bol. Pročitajte kako PHYSIOWRLD koristi savremene lasere u tretmanima rehabilitacije.",
          "image": "https://physiowrld.rs/images/blog/laserska-terapija-fizikalna-medicina.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/laserska-terapija-fizikalna-medicina",
          "datePublished": "2025-10-15",
          "dateModified": "2025-10-15"
        },
        {
          "@type": "BlogPosting",
          "headline": "Bol u leđima – uzroci, vrste i najefikasniji načini oporavka",
          "alternativeHeadline": "Najčešći uzroci bola u leđima i efikasne metode oporavka",
          "description": "Saznajte najčešće uzroke bola u leđima, razliku između mehaničkog i upalnog bola i efikasne metode oporavka koje preporučuju fizioterapeuti.",
          "image": "https://physiowrld.rs/images/blog/bol-u-ledjima-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/bol-u-ledjima-uzroci-vrste-oporavak",
          "datePublished": "2025-11-10",
          "dateModified": "2025-11-10"
        },
        {
          "@type": "BlogPosting",
          "headline": "Povrede kolena posle skijanja – simptomi, oporavak i terapija",
          "alternativeHeadline": "Najčešće povrede kolena nakon skijanja i oporavak",
          "description": "Povrede kolena posle skijanja su česte. Saznajte simptome, terapiju i kako ubrzati oporavak.",
          "image": "https://physiowrld.rs/images/blog/povrede-kolena-skijanje-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/povrede-kolena-posle-skijanja",
          "datePublished": "2026-01-07",
          "dateModified": "2026-01-07"
        },
        {
          "@type": "BlogPosting",
          "headline": "Bol u leđima posle skijanja – zašto nastaje i kako se leči",
          "alternativeHeadline": "Uzroci bola u leđima nakon skijanja i terapija",
          "description": "Uzroci bola u leđima nakon skijanja i kako fizikalna terapija pomaže.",
          "image": "https://physiowrld.rs/images/blog/bol-ledja-skijanje-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/bol-u-ledjima-posle-skijanja",
          "datePublished": "2026-01-07",
          "dateModified": "2026-01-07"
        },
        {
          "@type": "BlogPosting",
          "headline": "Povrede ramena i vrata posle skijanja",
          "alternativeHeadline": "Najčešće povrede vrata i ramena nakon skijanja",
          "description": "Najčešće povrede vrata i ramena posle skijanja i oporavak uz terapiju.",
          "image": "https://physiowrld.rs/images/blog/povrede-ramena-vrata-skijanje-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/povrede-ramena-vrata-posle-skijanja",
          "datePublished": "2026-01-07",
          "dateModified": "2026-01-07"
        },
        {
          "@type": "BlogPosting",
          "headline": "Prevencija povreda pre skijanja – kako se pripremiti za sezonu",
          "alternativeHeadline": "Priprema tela za ski sezonu",
          "description": "Kako sprečiti povrede pre ski sezone. Saveti fizioterapeuta za pripremu tela za skijanje.",
          "image": "https://physiowrld.rs/images/blog/prevencija-povreda-skijanje-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/prevencija-povreda-pre-skijanja",
          "datePublished": "2026-01-07",
          "dateModified": "2026-01-07"
        },
        {
          "@type": "BlogPosting",
          "headline": "Zagrevanje i istezanje pre skijanja – vežbe za prevenciju povreda",
          "alternativeHeadline": "Vežbe zagrevanja za skijaše",
          "description": "Vežbe zagrevanja i istezanja pre skijanja za prevenciju povreda. Saveti fizioterapeuta PHYSIOWRLD.",
          "image": "https://physiowrld.rs/images/blog/zagrevanje-istezanje-skijanje-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/zagrevanje-istezanje-pre-skijanja",
          "datePublished": "2026-01-07",
          "dateModified": "2026-01-07"
        },
        {
          "@type": "BlogPosting",
          "headline": "Skidanje masti shockwave terapijom – neinvazivni tretman",
          "alternativeHeadline": "Shockwave terapija za redukciju masnih naslaga",
          "description": "Shockwave terapija pomaže u skidanju masti i smanjenju celulita bez hirurgije. Saznajte kako funkcioniše tretman.",
          "image": "https://physiowrld.rs/images/blog/skidanje-masti-shockwave-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/skidanje-masti-shockwave-terapija",
          "datePublished": "2026-01-27",
          "dateModified": "2026-01-27"
        },
        {
          "@type": "BlogPosting",
          "headline": "Ishrana za skidanje masti – naučno dokazani saveti",
          "alternativeHeadline": "Pravilna ishrana za gubitak masnog tkiva",
          "description": "Pravilna ishrana je ključ za skidanje masti. Naučite koje namirnice ubrzavaju metabolizam.",
          "image": "https://physiowrld.rs/images/blog/ishrana-skidanje-masti-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Luka Dimkovski",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/ishrana-skidanje-masti-saveti",
          "datePublished": "2026-01-27",
          "dateModified": "2026-01-27"
        },
        {
          "@type": "BlogPosting",
          "headline": "Vežbe za skidanje masti – najefikasnije metode",
          "alternativeHeadline": "Trening za sagorevanje masti i oblikovanje tela",
          "description": "Koje vežbe su najbolje za skidanje masti? Naučite najefikasnije metode treninga.",
          "image": "https://physiowrld.rs/images/blog/vezbe-skidanje-masti-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Stefan Miljković",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/vezbe-za-skidanje-masti",
          "datePublished": "2026-01-27",
          "dateModified": "2026-01-27"
        },
        {
          "@type": "BlogPosting",
          "headline": "Celulit – uzroci, stadijumi i najefikasniji tretmani",
          "alternativeHeadline": "Šta je celulit i kako ga ukloniti",
          "description": "Saznajte šta je celulit, zašto nastaje i koji tretmani su najefikasniji za njegovo uklanjanje.",
          "image": "https://physiowrld.rs/images/blog/celulit-uzroci-tretman-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/celulit-uzroci-tretman",
          "datePublished": "2026-01-28",
          "dateModified": "2026-01-28"
        },
        {
          "@type": "BlogPosting",
          "headline": "Oblikovanje tela shockwave terapijom – neinvazivna metoda",
          "alternativeHeadline": "Body contouring bez operacije",
          "description": "Oblikujte telo bez operacije uz shockwave terapiju. Smanjite obim, zategnite kožu i poboljšajte konturu.",
          "image": "https://physiowrld.rs/images/blog/oblikovanje-tela-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/oblikovanje-tela-shockwave",
          "datePublished": "2026-01-28",
          "dateModified": "2026-01-28"
        },
        {
          "@type": "BlogPosting",
          "headline": "Zatezanje kože shockwave terapijom – prirodno pomlađivanje",
          "alternativeHeadline": "Skin tightening bez hirurgije",
          "description": "Zategnite opuštenu kožu bez operacije uz shockwave terapiju. Stimulišite kolagen, poboljšajte elastičnost.",
          "image": "https://physiowrld.rs/images/blog/zatezanje-koze-shockwave-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/zatezanje-koze-shockwave",
          "datePublished": "2026-01-28",
          "dateModified": "2026-01-28"
        },
        {
          "@type": "BlogPosting",
          "headline": "Sportska masaža – prednosti za sportiste i rekreativce",
          "alternativeHeadline": "Prednosti sportske masaže za oporavak i prevenciju",
          "description": "Sportska masaža ubrzava oporavak mišića, sprečava povrede i poboljšava performanse. Zakažite sportsku masažu u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/sportska-masaza-prednosti-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Luka Dimkovski",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/sportska-masaza-prednosti-sportisti",
          "datePublished": "2026-02-09",
          "dateModified": "2026-02-09"
        },
        {
          "@type": "BlogPosting",
          "headline": "Terapeutska masaža za bol u leđima i vratu",
          "alternativeHeadline": "Kako terapeutska masaža pomaže kod bola u leđima",
          "description": "Terapeutska masaža ublažava bol u leđima i vratu, opušta napete mišiće i poboljšava cirkulaciju. Zakažite u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/terapeutska-masaza-bol-ledja-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/terapeutska-masaza-bol-ledja-vrat",
          "datePublished": "2026-02-09",
          "dateModified": "2026-02-09"
        },
        {
          "@type": "BlogPosting",
          "headline": "Relaks masaža – kako smanjuje stres i napetost",
          "alternativeHeadline": "Prednosti relaks masaže za smanjenje stresa",
          "description": "Relaks masaža smanjuje stres, opušta napete mišiće i poboljšava kvalitet sna. Zakažite opuštajuću masažu u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/relaks-masaza-stres-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Snežana Šainović",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/relaks-masaza-smanjenje-stresa",
          "datePublished": "2026-02-09",
          "dateModified": "2026-02-09"
        },
        {
          "@type": "BlogPosting",
          "headline": "Fizikalna terapija posle operacije kuka – oporavak korak po korak",
          "alternativeHeadline": "Rehabilitacija posle operacije kuka",
          "description": "Fizikalna terapija posle operacije kuka ubrzava oporavak, vraća pokretljivost i snagu. Individualni program rehabilitacije u PHYSIOWRLD-u Novi Beograd.",
          "image": "https://physiowrld.rs/images/blog/fizikalna-terapija-posle-operacije-kuka-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/fizikalna-terapija-posle-operacije-kuka",
          "datePublished": "2026-02-17",
          "dateModified": "2026-02-17"
        },
        {
          "@type": "BlogPosting",
          "headline": "Ultrazvučna terapija – kako deluje i kada se primenjuje",
          "alternativeHeadline": "Terapijski ultrazvuk u fizikalnoj medicini",
          "description": "Ultrazvučna terapija ubrzava zarastanje tkiva, smanjuje bol i upalu. Saznajte kako deluje i zakažite u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/ultrazvucna-terapija-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Stefan Milošević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/ultrazvucna-terapija-kako-deluje",
          "datePublished": "2026-02-17",
          "dateModified": "2026-02-17"
        },
        {
          "@type": "BlogPosting",
          "headline": "Elektroterapija u fizikalnoj medicini – vrste i primena",
          "alternativeHeadline": "Vrste elektroterapije i njihova primena",
          "description": "Elektroterapija koristi električne impulse za smanjenje bola, jačanje mišića i ubrzanje oporavka. Zakažite u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/elektroterapija-fizikalna-medicina-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Luka Dimkovski",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/elektroterapija-fizikalna-medicina",
          "datePublished": "2026-02-17",
          "dateModified": "2026-02-17"
        },
        {
          "@type": "BlogPosting",
          "headline": "Kiropraktika za bol u kukovima – uzroci i tretman",
          "alternativeHeadline": "Kiropraktički tretman za bol u kuku",
          "description": "Kiropraktika efikasno ublažava bol u kukovima bez lekova. Zakažite kiropraktički tretman u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/kiropraktika-bol-kukovi-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/kiropraktika-bol-kukovi",
          "datePublished": "2026-02-21",
          "dateModified": "2026-02-21"
        },
        {
          "@type": "BlogPosting",
          "headline": "Kiropraktika i poboljšanje držanja tela – kako ispraviti posturu",
          "alternativeHeadline": "Korekcija posture kiropraktikom",
          "description": "Kiropraktika koriguje lošu posturu, smanjuje bol u leđima i vratu. Zakažite u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/kiropraktika-drzanje-tela-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/kiropraktika-drzanje-tela",
          "datePublished": "2026-02-21",
          "dateModified": "2026-02-21"
        },
        {
          "@type": "BlogPosting",
          "headline": "Kiropraktika za išijas – prirodni tretman bez lekova",
          "alternativeHeadline": "Kiropraktički tretman za išijas",
          "description": "Kiropraktika ublažava išijas bol prirodno, bez lekova i operacije. Zakažite u PHYSIOWRLD-u na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/kiropraktika-isijas-cover.webp",
          "author": {
            "@type": "Person",
            "name": "Filip Stanojević",
            "jobTitle": "Strukovni fizioterapeut",
            "url": "https://physiowrld.rs/"
          },
          "publisher": {
            "@type": "Organization",
            "name": "PHYSIOWRLD"
          },
          "mainEntityOfPage": "https://physiowrld.rs/blog/kiropraktika-isijas-prirodni-tretman",
          "datePublished": "2026-02-21",
          "dateModified": "2026-02-21"
        },
        {
          "@type": "BlogPosting",
          "headline": "Anatomija kičme – vodič kroz strukturu i funkciju kičmenog stuba",
          "alternativeHeadline": "Struktura i funkcija kičmenog stuba",
          "description": "Saznajte sve o anatomiji kičme – delovi, funkcije i najčešći problemi. Stručni vodič fizioterapeuta PHYSIOWRLD na Novom Beogradu.",
          "image": "https://physiowrld.rs/images/blog/anatomija-kicme-cover.webp",
          "author": { "@type": "Person", "name": "Filip Stanojević", "jobTitle": "Strukovni fizioterapeut", "url": "https://physiowrld.rs/" },
          "publisher": { "@type": "Organization", "name": "PHYSIOWRLD" },
          "mainEntityOfPage": "https://physiowrld.rs/blog/anatomija-kicme-vodic",
          "datePublished": "2026-02-21",
          "dateModified": "2026-02-21"
        },
        {
          "@type": "BlogPosting",
          "headline": "Lordoza – uzroci, simptomi i korekcija hiperlordoze",
          "alternativeHeadline": "Hiperlordoza – uzroci i korekcija",
          "description": "Saznajte šta je lordoza, kako prepoznati hiperlordozu i koje vežbe i terapije pomažu. PHYSIOWRLD Novi Beograd.",
          "image": "https://physiowrld.rs/images/blog/lordoza-cover.webp",
          "author": { "@type": "Person", "name": "Filip Stanojević", "jobTitle": "Strukovni fizioterapeut", "url": "https://physiowrld.rs/" },
          "publisher": { "@type": "Organization", "name": "PHYSIOWRLD" },
          "mainEntityOfPage": "https://physiowrld.rs/blog/lordoza-hiperlordoza-korekcija",
          "datePublished": "2026-02-21",
          "dateModified": "2026-02-21"
        },
        {
          "@type": "BlogPosting",
          "headline": "Kičmeni diskovi – struktura, funkcija i najčešća oštećenja",
          "alternativeHeadline": "Sve o kičmenim diskovima",
          "description": "Saznajte sve o kičmenim diskovima – struktura, funkcija, degeneracija i hernija. Tretman u PHYSIOWRLD-u Novi Beograd.",
          "image": "https://physiowrld.rs/images/blog/diskus-kicmeni-cover.webp",
          "author": { "@type": "Person", "name": "Filip Stanojević", "jobTitle": "Strukovni fizioterapeut", "url": "https://physiowrld.rs/" },
          "publisher": { "@type": "Organization", "name": "PHYSIOWRLD" },
          "mainEntityOfPage": "https://physiowrld.rs/blog/kicmeni-diskovi-struktura-ostecenja",
          "datePublished": "2026-02-21",
          "dateModified": "2026-02-21"
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'blog-schema';
    
    const existing = document.getElementById('blog-schema');
    if (existing) {
      existing.remove();
    }
    
    document.head.appendChild(script);

    return () => {
      const schemaScript = document.getElementById('blog-schema');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return null;
};

export default BlogSchema;
